import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

interface ReservationReceiptModalProps {
  isOpen: boolean;
  onClose: () => void;
  receiptUrl: string | null;
  reservationTitle: string;
}

export const ReservationReceiptModal = ({ 
  isOpen, 
  onClose, 
  receiptUrl, 
  reservationTitle 
}: ReservationReceiptModalProps) => {
  
  const handleDownload = () => {
    if (!receiptUrl) return;
    
    const link = document.createElement('a');
    link.href = receiptUrl;
    link.download = `comprobante_${reservationTitle.replace(/\s+/g, '_')}_${Date.now()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!receiptUrl) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-auto">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle>Comprobante de Pago - {reservationTitle}</DialogTitle>
            <div className="flex gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={onClose}
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </DialogHeader>
        
        <div className="mt-4">
          <div className="relative rounded-lg overflow-hidden bg-muted">
            <img
              src={receiptUrl}
              alt="Comprobante de pago"
              className="w-full h-auto max-h-[60vh] object-contain"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/placeholder.svg';
              }}
            />
          </div>
        </div>
        
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={onClose}>
            Cerrar
          </Button>
          <Button onClick={handleDownload}>
            <Download className="h-4 w-4 mr-2" />
            Descargar Comprobante
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};